var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: [
        "ecs-page",
        { "is-embedded": _vm.isEmbedded, content: !_vm.isEmbedded },
      ],
    },
    [
      _c("div", { staticClass: "ecs-header-card row-data" }, [
        _c("div", { staticClass: "ecs-header-main" }, [
          !_vm.isEmbedded
            ? _c(
                "div",
                { staticClass: "ecs-header-nav" },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "ecs-back-btn",
                      attrs: {
                        type: "default",
                        size: "small",
                        icon: "el-icon-back",
                      },
                      on: { click: _vm.goBackToEvaluation },
                    },
                    [_vm._v("\n          Quay lại nhận xét\n        ")]
                  ),
                  _vm._m(0),
                ],
                1
              )
            : _vm._e(),
          _vm._m(1),
        ]),
        _c("div", { staticClass: "ecs-header-stats" }, [
          _c("div", { staticClass: "ecs-stat-item" }, [
            _vm._m(2),
            _c("div", { staticClass: "ecs-stat-meta" }, [
              _c("span", { staticClass: "ecs-stat-val" }, [
                _vm._v(_vm._s(_vm.categories.length)),
              ]),
              _c("span", { staticClass: "ecs-stat-lbl" }, [_vm._v("Danh mục")]),
            ]),
          ]),
          _c("div", { staticClass: "ecs-stat-divider" }),
          _c("div", { staticClass: "ecs-stat-item" }, [
            _vm._m(3),
            _c("div", { staticClass: "ecs-stat-meta" }, [
              _c("span", { staticClass: "ecs-stat-val" }, [
                _vm._v(
                  _vm._s(_vm.selectedCategory ? _vm.templates.length : "—")
                ),
              ]),
              _c("span", { staticClass: "ecs-stat-lbl" }, [
                _vm._v(
                  _vm._s(
                    _vm.selectedCategory ? "Mẫu đang chọn" : "Chưa chọn mục"
                  )
                ),
              ]),
            ]),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "ecs-grid-container row-data" }, [
        _c("div", { staticClass: "ecs-panel-card ecs-panel-categories" }, [
          _c(
            "div",
            { staticClass: "ecs-panel-header" },
            [
              _c("div", { staticClass: "ecs-panel-title-wrap" }, [
                _vm._m(4),
                _c("div", [
                  _c("h2", { staticClass: "ecs-panel-title" }, [
                    _vm._v("\n              Danh mục đánh giá\n              "),
                    _c("span", { staticClass: "ecs-badge" }, [
                      _vm._v(_vm._s(_vm.categories.length)),
                    ]),
                  ]),
                  _c("p", { staticClass: "ecs-panel-desc" }, [
                    _vm._v("Nhấp chọn danh mục để xem mẫu nhận xét tương ứng"),
                  ]),
                ]),
              ]),
              _c(
                "el-button",
                {
                  staticClass: "ecs-btn-primary",
                  attrs: {
                    type: "primary",
                    size: "small",
                    icon: "el-icon-plus",
                  },
                  on: { click: _vm.openCreateCategory },
                },
                [_vm._v("\n          Thêm danh mục\n        ")]
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "ecs-table-container" },
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.categoryLoading,
                      expression: "categoryLoading",
                    },
                  ],
                  staticClass: "sk-table ecs-cat-table",
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.categories,
                    border: "",
                    size: "small",
                    "highlight-current-row": "",
                    "row-class-name": _vm.getCategoryRowClass,
                  },
                  on: { "row-click": _vm.handleCategoryRowClick },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: "STT",
                      type: "index",
                      width: "50",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Tên danh mục",
                      prop: "name",
                      "min-width": "160",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "div",
                              { staticClass: "ecs-cat-name-cell" },
                              [
                                _c("i", {
                                  class: [
                                    "el-icon-folder",
                                    {
                                      "is-active":
                                        _vm.selectedCategoryId === row.id,
                                    },
                                  ],
                                }),
                                _c(
                                  "span",
                                  { staticClass: "ecs-cat-name-text" },
                                  [_vm._v(_vm._s(row.name))]
                                ),
                                _vm.selectedCategoryId === row.id
                                  ? _c(
                                      "el-tag",
                                      {
                                        staticClass: "ecs-active-pill",
                                        attrs: {
                                          size: "mini",
                                          type: "primary",
                                          effect: "dark",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  Đang chọn\n                "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Thứ tự",
                      prop: "orderIndex",
                      width: "65",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Thao tác",
                      width: "95",
                      align: "center",
                      fixed: "right",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "div",
                              {
                                staticClass: "ecs-row-actions",
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                  },
                                },
                              },
                              [
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      content: "Chỉnh sửa danh mục",
                                      placement: "top",
                                    },
                                  },
                                  [
                                    _c("el-button", {
                                      staticClass: "ecs-circle-btn",
                                      attrs: {
                                        type: "primary",
                                        icon: "el-icon-edit",
                                        size: "mini",
                                        circle: "",
                                        plain: "",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.openEditCategory(row)
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      content: "Xoá danh mục",
                                      placement: "top",
                                    },
                                  },
                                  [
                                    _c("el-button", {
                                      staticClass: "ecs-circle-btn ml-1",
                                      attrs: {
                                        type: "danger",
                                        icon: "el-icon-delete",
                                        size: "mini",
                                        circle: "",
                                        plain: "",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleDeleteCategory(row)
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]),
        _c("div", { staticClass: "ecs-panel-card ecs-panel-templates" }, [
          _c("div", { staticClass: "ecs-panel-header" }, [
            _c("div", { staticClass: "ecs-panel-title-wrap" }, [
              _vm._m(5),
              _c("div", [
                _c("h2", { staticClass: "ecs-panel-title" }, [
                  _vm._v("\n              Mẫu nhận xét\n              "),
                  _vm.selectedCategory
                    ? _c(
                        "span",
                        { staticClass: "ecs-badge ecs-badge--active" },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.templates.length) +
                              " mẫu\n              "
                          ),
                        ]
                      )
                    : _vm._e(),
                ]),
                _c("p", { staticClass: "ecs-panel-desc" }, [
                  _vm.selectedCategory
                    ? _c("span", [
                        _vm._v("\n                Danh mục: "),
                        _c("strong", [
                          _vm._v(_vm._s(_vm.selectedCategory.name)),
                        ]),
                      ])
                    : _c("span", [
                        _vm._v("Chọn một danh mục để tải danh sách mẫu"),
                      ]),
                ]),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "ecs-panel-actions" },
              [
                _c(
                  "el-select",
                  {
                    staticClass: "ecs-cat-selector",
                    attrs: { placeholder: "Chọn danh mục...", size: "small" },
                    on: { change: _vm.fetchTemplates },
                    model: {
                      value: _vm.selectedCategoryId,
                      callback: function ($$v) {
                        _vm.selectedCategoryId = $$v
                      },
                      expression: "selectedCategoryId",
                    },
                  },
                  _vm._l(_vm.categories, function (cat) {
                    return _c("el-option", {
                      key: cat.id,
                      attrs: { label: cat.name, value: cat.id },
                    })
                  }),
                  1
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "ecs-btn-primary",
                    attrs: {
                      type: "primary",
                      size: "small",
                      icon: "el-icon-plus",
                      disabled: !_vm.selectedCategoryId,
                    },
                    on: { click: _vm.openCreateTemplate },
                  },
                  [_vm._v("\n            Thêm mẫu\n          ")]
                ),
              ],
              1
            ),
          ]),
          _c(
            "div",
            { staticClass: "ecs-table-container" },
            [
              !_vm.selectedCategoryId && !_vm.templateLoading
                ? _c("div", { staticClass: "ecs-empty-state" }, [
                    _vm._m(6),
                    _c("h3", { staticClass: "ecs-empty-title" }, [
                      _vm._v("Chưa chọn danh mục đánh giá"),
                    ]),
                    _c("p", { staticClass: "ecs-empty-text" }, [
                      _vm._v(
                        "\n            Nhấp vào một dòng danh mục ở bảng bên trái hoặc chọn từ danh sách thả xuống ở góc trên để hiển thị các mẫu nhận xét.\n          "
                      ),
                    ]),
                  ])
                : _vm.selectedCategoryId &&
                  _vm.templates.length === 0 &&
                  !_vm.templateLoading
                ? _c(
                    "div",
                    { staticClass: "ecs-empty-state" },
                    [
                      _vm._m(7),
                      _c("h3", { staticClass: "ecs-empty-title" }, [
                        _vm._v("Chưa có mẫu nhận xét nào"),
                      ]),
                      _c("p", { staticClass: "ecs-empty-text" }, [
                        _vm._v('\n            Danh mục "'),
                        _c("strong", [
                          _vm._v(_vm._s(_vm.selectedCategoryName)),
                        ]),
                        _vm._v(
                          '" hiện chưa có câu mẫu nhận xét nào.\n          '
                        ),
                      ]),
                      _c(
                        "el-button",
                        {
                          staticClass: "ecs-btn-primary mt-3",
                          attrs: {
                            type: "primary",
                            size: "small",
                            icon: "el-icon-plus",
                          },
                          on: { click: _vm.openCreateTemplate },
                        },
                        [
                          _vm._v(
                            "\n            Thêm mẫu nhận xét đầu tiên\n          "
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                : _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.templateLoading,
                          expression: "templateLoading",
                        },
                      ],
                      staticClass: "sk-table ecs-tpl-table",
                      staticStyle: { width: "100%" },
                      attrs: { data: _vm.templates, border: "", size: "small" },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: "STT",
                          type: "index",
                          width: "50",
                          align: "center",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "Nội dung mẫu nhận xét",
                          prop: "content",
                          "min-width": "300",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "ecs-tpl-content-cell" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        class: [
                                          "ecs-desc",
                                          {
                                            expanded: _vm.isDescExpanded(
                                              row.id
                                            ),
                                          },
                                        ],
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(row.content) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "ecs-tpl-footer-row" },
                                      [
                                        _vm.showDescToggle(row.content)
                                          ? _c(
                                              "a",
                                              {
                                                staticClass: "ecs-expand-link",
                                                attrs: { href: "#" },
                                                on: {
                                                  click: function ($event) {
                                                    $event.preventDefault()
                                                    return _vm.toggleDesc(
                                                      row.id
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.isDescExpanded(row.id)
                                                        ? "Thu gọn"
                                                        : "Xem thêm"
                                                    ) +
                                                    "\n                  "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _c(
                                          "el-tooltip",
                                          {
                                            attrs: {
                                              content: "Sao chép nội dung",
                                              placement: "top",
                                            },
                                          },
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass: "ecs-copy-btn",
                                                attrs: { type: "button" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.copyTemplateText(
                                                      row.content
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-document-copy",
                                                }),
                                                _vm._v(
                                                  " Sao chép\n                    "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "Thao tác",
                          width: "95",
                          align: "center",
                          fixed: "right",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "ecs-row-actions" },
                                  [
                                    _c(
                                      "el-tooltip",
                                      {
                                        attrs: {
                                          content: "Chỉnh sửa mẫu",
                                          placement: "top",
                                        },
                                      },
                                      [
                                        _c("el-button", {
                                          staticClass: "ecs-circle-btn",
                                          attrs: {
                                            type: "primary",
                                            icon: "el-icon-edit",
                                            size: "mini",
                                            circle: "",
                                            plain: "",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.openEditTemplate(row)
                                            },
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-tooltip",
                                      {
                                        attrs: {
                                          content: "Xoá mẫu nhận xét",
                                          placement: "top",
                                        },
                                      },
                                      [
                                        _c("el-button", {
                                          staticClass: "ecs-circle-btn ml-1",
                                          attrs: {
                                            type: "danger",
                                            icon: "el-icon-delete",
                                            size: "mini",
                                            circle: "",
                                            plain: "",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleDeleteTemplate(
                                                row
                                              )
                                            },
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
            ],
            1
          ),
        ]),
      ]),
      _c(
        "DialogBase",
        {
          attrs: {
            visible: _vm.categoryDialogVisible,
            title: _vm.categoryDialogTitle,
            size: "sm",
            "confirm-loading": _vm.categorySaving,
            "confirm-text": "Lưu danh mục",
            "cancel-text": "Huỷ bỏ",
            "use-panel": true,
            "panel-title": "Danh mục đánh giá",
            "panel-subtitle": _vm.categoryEditMode
              ? "Cập nhật thông tin danh mục đánh giá"
              : "Tạo mới danh mục tiêu chí đánh giá",
            "panel-icon": "el-icon-folder",
          },
          on: {
            "update:visible": function ($event) {
              _vm.categoryDialogVisible = $event
            },
            confirm: _vm.handleSaveCategory,
            cancel: function ($event) {
              _vm.categoryDialogVisible = false
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "categoryForm",
              staticClass: "ecs-dialog-form",
              attrs: {
                model: _vm.categoryForm,
                rules: _vm.categoryRules,
                "label-position": "top",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "Tên danh mục", prop: "name" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder:
                        "VD: Học tập, Kỹ năng sống, Nề nếp, Thể chất...",
                      maxlength: "100",
                      clearable: "",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.categoryForm.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.categoryForm, "name", $$v)
                      },
                      expression: "categoryForm.name",
                    },
                  }),
                ],
                1
              ),
              !_vm.categoryEditMode
                ? _c("div", { staticClass: "ecs-quick-tags-section" }, [
                    _c("span", { staticClass: "ecs-quick-tags-label" }, [
                      _c("i", { staticClass: "el-icon-magic-stick" }),
                      _vm._v(" Gợi ý nhanh:"),
                    ]),
                    _c(
                      "div",
                      { staticClass: "ecs-quick-tags-list" },
                      _vm._l(_vm.presetCategoryTags, function (tag) {
                        return _c(
                          "span",
                          {
                            key: tag,
                            staticClass: "ecs-quick-tag",
                            on: {
                              click: function ($event) {
                                return _vm.selectPresetTag(tag)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n            + " + _vm._s(tag) + "\n          "
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                  ])
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  staticClass: "mt-3",
                  attrs: { label: "Thứ tự hiển thị", prop: "orderIndex" },
                },
                [
                  _c("el-input-number", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      min: 1,
                      max: 99,
                      placeholder: "Thứ tự",
                      "controls-position": "right",
                    },
                    model: {
                      value: _vm.categoryForm.orderIndex,
                      callback: function ($$v) {
                        _vm.$set(_vm.categoryForm, "orderIndex", $$v)
                      },
                      expression: "categoryForm.orderIndex",
                    },
                  }),
                  _c("span", { staticClass: "ecs-form-hint" }, [
                    _vm._v(
                      "Số nhỏ hơn sẽ được ưu tiên hiển thị trước trong bảng đánh giá"
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "DialogBase",
        {
          attrs: {
            visible: _vm.templateDialogVisible,
            title: _vm.templateDialogTitle,
            size: "md",
            "confirm-loading": _vm.templateSaving,
            "confirm-text": "Lưu mẫu",
            "cancel-text": "Huỷ bỏ",
            "use-panel": true,
            "panel-title": "Mẫu nhận xét",
            "panel-subtitle": _vm.templateEditMode
              ? "Cập nhật nội dung câu mẫu nhận xét"
              : "Tạo mới nội dung câu mẫu nhận xét",
            "panel-icon": "el-icon-document-add",
          },
          on: {
            "update:visible": function ($event) {
              _vm.templateDialogVisible = $event
            },
            confirm: _vm.handleSaveTemplate,
            cancel: function ($event) {
              _vm.templateDialogVisible = false
            },
          },
        },
        [
          _vm.selectedCategory
            ? _c("div", { staticClass: "ecs-dialog-context-banner" }, [
                _c("i", { staticClass: "el-icon-folder" }),
                _c("span", [
                  _vm._v("Thuộc danh mục: "),
                  _c("strong", [_vm._v(_vm._s(_vm.selectedCategory.name))]),
                ]),
              ])
            : _vm._e(),
          _c(
            "el-form",
            {
              ref: "templateForm",
              staticClass: "ecs-dialog-form",
              attrs: {
                model: _vm.templateForm,
                rules: _vm.templateRules,
                "label-position": "top",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "Nội dung mẫu nhận xét", prop: "content" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 5,
                      placeholder:
                        "Nhập nội dung mẫu nhận xét chi tiết (VD: Bé ngoan ngoãn, tích cực phát biểu xây dựng bài và phối hợp tốt cùng cô giáo trong các hoạt động trên lớp)...",
                      maxlength: "500",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.templateForm.content,
                      callback: function ($$v) {
                        _vm.$set(_vm.templateForm, "content", $$v)
                      },
                      expression: "templateForm.content",
                    },
                  }),
                  _c("div", { staticClass: "ecs-form-tip" }, [
                    _c("i", { staticClass: "el-icon-info" }),
                    _c("span", [
                      _vm._v(
                        "Mẹo: Nội dung nên ngắn gọn, tích cực và súc tích để giáo viên dễ dàng áp dụng khi đánh giá học sinh."
                      ),
                    ]),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "ecs-breadcrumb-text" }, [
      _c("span", [_vm._v("Học sinh")]),
      _c("i", { staticClass: "el-icon-arrow-right ecs-bc-sep" }),
      _c("span", [_vm._v("Nhận xét học sinh")]),
      _c("i", { staticClass: "el-icon-arrow-right ecs-bc-sep" }),
      _c("span", { staticClass: "ecs-bc-current" }, [
        _vm._v("Cấu hình danh mục & Mẫu"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "ecs-title-section" }, [
      _c("div", { staticClass: "ecs-title-icon-wrap" }, [
        _c("i", { staticClass: "el-icon-s-opportunity" }),
      ]),
      _c("div", { staticClass: "ecs-title-content" }, [
        _c("h1", { staticClass: "ecs-page-title" }, [
          _vm._v("Cấu hình Danh mục & Mẫu nhận xét"),
        ]),
        _c("p", { staticClass: "ecs-page-subtitle" }, [
          _vm._v(
            "\n            Quản lý các tiêu chí đánh giá và ngân hàng mẫu câu nhận xét định sẵn để giáo viên dễ dàng áp dụng khi nhận xét học sinh\n          "
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "ecs-stat-icon" }, [
      _c("i", { staticClass: "el-icon-folder" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "ecs-stat-icon ecs-stat-icon--highlight" },
      [_c("i", { staticClass: "el-icon-document" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "ecs-panel-icon" }, [
      _c("i", { staticClass: "el-icon-folder-opened" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "ecs-panel-icon ecs-panel-icon--doc" }, [
      _c("i", { staticClass: "el-icon-document-copy" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "ecs-empty-icon" }, [
      _c("i", { staticClass: "el-icon-folder-opened" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "ecs-empty-icon ecs-empty-icon--add" }, [
      _c("i", { staticClass: "el-icon-document-add" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }